const STORAGE_KEY = 'renew:selected-gifts:v1'

export function buildBasketHash(basket) {
  if (!Array.isArray(basket) || basket.length === 0) return ''
  return basket
    .map((item) => `${item?.select_type?.id}:${item?.select_count}`)
    .sort()
    .join('|')
}

export function readGiftSelection() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed.basketHash !== 'string' || !Array.isArray(parsed.selectedGifts)) {
      return null
    }
    return parsed
  } catch (e) {
    return null
  }
}

export function writeGiftSelection(basketHash, selectedGifts) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ basketHash, selectedGifts }),
    )
  } catch (e) {}
}

export function clearGiftSelection() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {}
}

export const GIFT_STORAGE_KEY = STORAGE_KEY
